var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleBlockOpti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1410,
    height: 382,
    viewBox: "0 0 373.06 101.07",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10902",
    gradientTransform: "matrix(.26458 0 0 .26458 1097.6 -7.3527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007291",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7490",
    gradientTransform: "translate(-41.842 92.049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeb02b",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7474",
    gradientTransform: "matrix(.32513 0 0 .25174 -7.2155 123.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bc5626",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3260",
    gradientTransform: "matrix(1.3608 0 0 .80758 1.2915 5.813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfad6",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3254",
    gradientTransform: "translate(163.45 -287.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563128",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3248",
    gradientTransform: "matrix(.31658 0 0 .22431 41.319 16.041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeb02b",
    offset: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.5025,
    y: 3.3886,
    width: 366.25,
    height: 94.635,
    ry: 17.156,
    fill: "url(#linearGradient3260)",
    stroke: "url(#linearGradient7474)",
    strokeWidth: 5.1698
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.0388,
    y: 8.5375,
    width: 356.62,
    height: 84.325,
    ry: 12.343,
    fill: "url(#linearGradient3260)",
    stroke: "url(#linearGradient3248)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#linearGradient10902)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.761 69.419s6.1904 6.4472 13.044 6.6947c7.1104-0.11584 10.364-6.471 18.309-6.6077 7.7402 0.07601 14.157 6.7816 14.157 6.7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.034 76.242s6.1904 6.4472 13.044 6.6947c7.1104-0.11584 10.364-6.471 18.309-6.6077 7.7402 0.07601 14.157 6.7816 14.157 6.7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.48 70.125s6.1904 6.4472 13.044 6.6947c7.1104-0.11584 10.364-6.471 18.309-6.6077 7.7402 0.07601 14.157 6.7816 14.157 6.7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.75 76.948s6.1904 6.4472 13.044 6.6947c7.1104-0.11584 10.364-6.471 18.309-6.6077 7.7402 0.07601 14.157 6.7816 14.157 6.7816"
  })))), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Righteous",
    fontSize: "16.933px",
    strokeLinecap: "round",
    strokeMiterlimit: 2.6,
    strokeWidth: 3,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 106.75044,
    y: 58.618042,
    fill: "url(#linearGradient7490)",
    stroke: "url(#linearGradient7474)",
    strokeLinejoin: "round",
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 106.75044,
    y: 58.618042,
    fill: "url(#linearGradient7490)",
    fontFamily: "Righteous",
    fontSize: "50.8px",
    fontStyle: "regular",
    stroke: "url(#linearGradient7474)",
    strokeLinejoin: "round",
    strokeWidth: 3,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Will It")), /*#__PURE__*/React.createElement("text", {
    x: 262.93143,
    y: 58.804363,
    fill: "#62ba90",
    stroke: "url(#linearGradient10902)",
    strokeLinejoin: "round",
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 262.93143,
    y: 58.804363,
    fill: "#62ba90",
    fontFamily: "Righteous",
    fontSize: "50.8px",
    fontStyle: "regular",
    stroke: "url(#linearGradient10902)",
    strokeLinejoin: "round",
    strokeWidth: 3,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Swim?")), /*#__PURE__*/React.createElement("text", {
    x: 181.8969,
    y: 83.572739,
    fill: "url(#linearGradient3254)",
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 181.8969,
    y: 83.572739,
    fill: "url(#linearGradient3254)",
    fontFamily: "Righteous",
    fontSize: "19.756px",
    strokeWidth: 3,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Austin Greenbelt Water"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBlockOpti);
export default __webpack_public_path__ + "static/media/title_block_opti.49864c7d0ea608da63475848e50fc19c.svg";
export { ForwardRef as ReactComponent };